module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/report@2x-79b57e1af06845f79e7f7e420eb1daf3.png";